import { ApiMethods, appAPI } from '.';
import { OnboardingStatus } from '../../constants';

interface PatchDismissalStateParams {
  fields: Partial<OnboardingStatus['fields']>;
}

export const improvedOnboardingApi = appAPI.injectEndpoints({
  endpoints: build => ({
    patchDismissalState: build.mutation<
      OnboardingStatus,
      PatchDismissalStateParams
    >({
      query: entity => ({
        path: `/onboarding-task-status`,
        method: ApiMethods.patch,
        options: {
          body: {
            ...entity,
          },
        },
      }),
    }),
  }),
});

export const { usePatchDismissalStateMutation } = improvedOnboardingApi;
